import Vue from 'vue';
import currencyFormatter from 'currencyformatter.js'

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    return currencyFormatter.format(value, { currency: 'CHF' });
});

Vue.filter('toCurrencyWithoutDecimals', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    return currencyFormatter.format(value, { currency: 'CHF' , pattern: '! #,###.'});
});

Vue.filter('toCurrencyWithoutSymbol', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    return currencyFormatter.format(value, { currency: 'CHF', symbol: ''});
});

Vue.filter('toCurrencyWithoutSymbolAndDecimals', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    return currencyFormatter.format(value, { currency: 'CHF', symbol: '', pattern: '#,###.'});
});